export default "__VITE_ASSET__BlxgHgMh__"